import { BaseModel } from "sjs-base-model";

export default class ContentModel extends BaseModel {
    public readonly canRead: boolean = true;
    public readonly canSeek: boolean = true;
    public readonly canTimeout: boolean = true;
    public readonly canWrite: boolean = true;
    public readonly length: number = 0;
    public readonly position: number = 0;
    public readonly readTimeout: number = 0;
    public readonly writeTimeout: number = 0;

    constructor(data: Partial<ContentModel>) {
        super();

        this.update(data);
    }
}
